module.exports = __webpack_public_path__ + "static/thistle-ed7731d3b8a8faf42bc482a6bbdd7eac.png";